import React from 'react'
import { Box, Paper, Tabs, Tab } from '@mui/material'

interface TabDef {
  value: string
  label: string
}

interface Props {
  title?: string
  tabs?: TabDef[]
  tabValue?: string
  onTabChange?: (newValue: string) => void
  children?: React.ReactNode
}

export default function InventoryShell(props: Props) {
  const { tabs, tabValue, onTabChange, children } = props

  return (
    <Box>
      <Paper>
        {tabs && (
          <Tabs
            variant="scrollable"
            scrollButtons="auto"
            value={tabValue}
            onChange={(e, newValue) => onTabChange && onTabChange(newValue)}
          >
            {tabs.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} />
            ))}
          </Tabs>
        )}
      </Paper>
      <Box mt={1} />
      {children}
    </Box>
  )
}
